import DeviceType from '../../types/Device';

import { DeviceTypeProviderAction } from './types';

const deviceTypeReducer = (state: DeviceType, action: DeviceTypeProviderAction): DeviceType => {
	switch (action.type) {
		case 'set-device-type':
			return action.deviceType;
		case 'update-device-type':
			return { ...state, ...action.deviceType };
	}

	return state;
};

export default deviceTypeReducer;
